function gxgFormSubmitLoaderInit() {
	document.body.insertAdjacentHTML(
		'beforeend',
		'<div class="gxg-form-fullscreen-loader"><div class="gxg-form-spinner"></div></div>'
	);

	const formEls = Array.from(document.querySelectorAll('form'));

	formEls.forEach((formEl) => {
		formEl.addEventListener('submit', (e) => {
			document.documentElement.classList.add('gxg-form-fullscreen-loader--active');

			if (!e.currentTarget) {
				return;
			}

			const formWrapperEl = e.currentTarget.closest('.gform_wrapper');

			if (!formWrapperEl || !formWrapperEl.parentNode) {
				return;
			}

			const observer = new MutationObserver((mutationsList, curObserver) => {
				document.documentElement.classList.remove('gxg-form-fullscreen-loader--active');

				if (curObserver) {
					curObserver.disconnect();
				}
			});

			observer.observe(formWrapperEl.parentNode, { attributes: true, childList: true, subtree: true });
		});
	});
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', () => {
		gxgFormSubmitLoaderInit();
	});
} else {
	gxgFormSubmitLoaderInit();
}
